var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:({
    src: _vm.bg,
  }),expression:"{\n    src: bg,\n  }",arg:"background-image"}],staticClass:"parent"},[_c('title-widge',{attrs:{"title":_vm.title,"subTitle":_vm.subTitle,"titleColor":_vm.titleColor,"subTitleColor":_vm.subTitleColor}}),_c('div',{staticClass:"divContent"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:({
        src: _vm.bgUrl,
        loading: require('./../../../../../assets/wheelplanting.jpg'),
      }),expression:"{\n        src: bgUrl,\n        loading: require('./../../../../../assets/wheelplanting.jpg'),\n      }"}]})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }